'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.selectPlan = exports.loadCardData = undefined;

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

exports.doLoadCreditStat = doLoadCreditStat;
exports.doLoadPlanData = doLoadPlanData;
exports.doLoadPromotionData = doLoadPromotionData;
exports.doLoadCardData = doLoadCardData;
exports.doSelectPlan = doSelectPlan;
exports.loadSaga = loadSaga;
exports.watchSaga = watchSaga;

var _sagaTools = require('@classpass/saga-tools');

var _reactRouterRedux = require('react-router-redux');

var _effects = require('redux-saga/effects');

var _universalLogger = require('universal-logger');

var logger = _interopRequireWildcard(_universalLogger);

var _Base = require('derivers/Base64');

var _Base2 = _interopRequireDefault(_Base);

var _optimizely = require('helpers/optimizely');

var _verify = require('helpers/verify');

var _bound = require('redux/saga/entities/bound');

var _location = require('containers/LocationModal/location.saga');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _marked = /*#__PURE__*/_regenerator2.default.mark(doLoadCreditStat),
    _marked2 = /*#__PURE__*/_regenerator2.default.mark(doLoadPlanData),
    _marked3 = /*#__PURE__*/_regenerator2.default.mark(doLoadPromotionData),
    _marked4 = /*#__PURE__*/_regenerator2.default.mark(doLoadCardData),
    _marked5 = /*#__PURE__*/_regenerator2.default.mark(doSelectPlan),
    _marked6 = /*#__PURE__*/_regenerator2.default.mark(loadSaga),
    _marked7 = /*#__PURE__*/_regenerator2.default.mark(watchSaga);

var loadCardData = exports.loadCardData = function loadCardData(plansModuleConfig) {
  return {
    type: 'PLAN_SELECTION_LOAD_CARD_DATA', plansModuleConfig: plansModuleConfig
  };
};
var selectPlan = exports.selectPlan = function selectPlan(itemType, itemId) {
  return {
    type: 'PLAN_SELECTION_SELECT_PLAN', itemType: itemType, itemId: itemId
  };
};

function doLoadCreditStat(client, msa) {
  return _regenerator2.default.wrap(function doLoadCreditStat$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.prev = 0;
          _context.next = 3;
          return (0, _effects.call)(_sagaTools.fetchEntityIfNeeded, _bound.msaCreditStatById, [client, msa.id]);

        case 3:
          _context.next = 8;
          break;

        case 5:
          _context.prev = 5;
          _context.t0 = _context['catch'](0);

          logger.warn('Failed to find credit stat for msa [' + msa.id + ']', _context.t0);

        case 8:
        case 'end':
          return _context.stop();
      }
    }
  }, _marked, this, [[0, 5]]);
}

function doLoadPlanData(client, msa) {
  return _regenerator2.default.wrap(function doLoadPlanData$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          _context2.prev = 0;
          _context2.next = 3;
          return (0, _effects.call)(_sagaTools.fetchEntityIfNeeded, _bound.plansByMsa, [client, msa.id]);

        case 3:
          _context2.next = 8;
          break;

        case 5:
          _context2.prev = 5;
          _context2.t0 = _context2['catch'](0);

          logger.warn('Failed to find plans for msa [' + msa.id + ']', _context2.t0);

        case 8:
        case 'end':
          return _context2.stop();
      }
    }
  }, _marked2, this, [[0, 5]]);
}

function doLoadPromotionData(client, msa, promotionAlias) {
  return _regenerator2.default.wrap(function doLoadPromotionData$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          _context3.prev = 0;
          _context3.next = 3;
          return (0, _effects.call)(_sagaTools.fetchEntityIfNeeded, _bound.promotionByAlias, [client, promotionAlias, msa.id]);

        case 3:
          _context3.next = 8;
          break;

        case 5:
          _context3.prev = 5;
          _context3.t0 = _context3['catch'](0);

          logger.warn('Failed to find promotion for alias [' + promotionAlias + '] in msa [' + msa.id + ']', _context3.t0);

        case 8:
        case 'end':
          return _context3.stop();
      }
    }
  }, _marked3, this, [[0, 5]]);
}

function doLoadCardData(client, _ref) {
  var plansModuleConfig = _ref.plansModuleConfig;

  var _ref2, moduleType, promotionAlias, msa;

  return _regenerator2.default.wrap(function doLoadCardData$(_context4) {
    while (1) {
      switch (_context4.prev = _context4.next) {
        case 0:
          _ref2 = plansModuleConfig || {}, moduleType = _ref2.type, promotionAlias = _ref2.promotionAlias;
          _context4.next = 3;
          return (0, _effects.call)(_location.getMsa, client);

        case 3:
          msa = _context4.sent;

          if (!(0, _verify.isEmpty)(msa)) {
            _context4.next = 6;
            break;
          }

          return _context4.abrupt('return');

        case 6:
          _context4.next = 8;
          return (0, _effects.all)([(0, _effects.call)(doLoadCreditStat, client, msa), moduleType === 'checkoutPlansModuleType' && (0, _effects.call)(doLoadPlanData, client, msa), moduleType === 'promotionPlansModuleType' && (0, _effects.call)(doLoadPromotionData, client, msa, promotionAlias)].filter(Boolean));

        case 8:
        case 'end':
          return _context4.stop();
      }
    }
  }, _marked4, this);
}

function doSelectPlan(client, _ref3) {
  var itemType = _ref3.itemType,
      itemId = _ref3.itemId;
  return _regenerator2.default.wrap(function doSelectPlan$(_context5) {
    while (1) {
      switch (_context5.prev = _context5.next) {
        case 0:
          if (!(!itemId || !itemType)) {
            _context5.next = 2;
            break;
          }

          return _context5.abrupt('return');

        case 2:
          _context5.next = 4;
          return (0, _effects.spawn)(_optimizely.trackOptimizelyEvent, 'successful_plan_selection');

        case 4:
          _context5.next = 6;
          return (0, _effects.put)((0, _reactRouterRedux.push)('/signup/' + itemType + '/' + _Base2.default.encode(itemId)));

        case 6:
        case 'end':
          return _context5.stop();
      }
    }
  }, _marked5, this);
}

function loadSaga(client, props) {
  return _regenerator2.default.wrap(function loadSaga$(_context6) {
    while (1) {
      switch (_context6.prev = _context6.next) {
        case 0:
          _context6.next = 2;
          return (0, _effects.call)(doLoadCardData, client, { plansModuleConfig: props.plansModuleType });

        case 2:
        case 'end':
          return _context6.stop();
      }
    }
  }, _marked6, this);
}

function watchSaga(client) {
  return _regenerator2.default.wrap(function watchSaga$(_context7) {
    while (1) {
      switch (_context7.prev = _context7.next) {
        case 0:
          _context7.next = 2;
          return (0, _effects.fork)(_effects.takeEvery, loadCardData().type, doLoadCardData, client);

        case 2:
          _context7.next = 4;
          return (0, _effects.fork)(_effects.takeEvery, selectPlan().type, doSelectPlan, client);

        case 4:
        case 'end':
          return _context7.stop();
      }
    }
  }, _marked7, this);
}